"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Analytics;
(function (Analytics) {
    Analytics.checkedIn = 'ca-check-in';
    Analytics.createMemo = 'ca-create-memo';
    Analytics.addComment = 'ca-add-comment';
    Analytics.addHeart = 'ca-add-heart';
    Analytics.activityLibraryGDrive = 'ca-activity-library-gdrive';
    Analytics.userType = 'ca_user_type';
    Analytics.userRole = 'ca_user_role';
    Analytics.internalUser = 'internal';
    Analytics.externalUser = 'external';
})(Analytics = exports.Analytics || (exports.Analytics = {}));
